import { callRpc } from '../utils/rpc';

export async function buildSchema(db, schema, contextVars) {
  const { data, error } = await callRpc(
    db,
    'api.apply_overrides',
    {
      in_schema:  schema,
      in_params:  contextVars
    }
  );

  if (error) {
    console.error('RPC Error:', error);
    throw new Error(error);
  }

  try {
    return data;
  } catch (e) {
    console.error('Invalid JSON from apply_overrides:', e);
    throw new Error('Réponse JSON invalide');
  }
}